var Swiper = require('react-native-web-swiper').default;

exports._swiper = Swiper;
